module.exports = __webpack_public_path__ + "img/illu_04.3666dc03.svg";